import { __read, __spread } from "tslib";
import { print } from 'graphql';
export function concatenateTypeDefs(typeDefinitionsAry, calledFunctionRefs) {
    if (calledFunctionRefs === void 0) { calledFunctionRefs = new Set(); }
    var resolvedTypeDefinitions = new Set();
    typeDefinitionsAry.forEach(function (typeDef) {
        if (typeof typeDef === 'function') {
            if (!calledFunctionRefs.has(typeDef)) {
                calledFunctionRefs.add(typeDef);
                resolvedTypeDefinitions.add(concatenateTypeDefs(typeDef(), calledFunctionRefs));
            }
        }
        else if (typeof typeDef === 'string') {
            resolvedTypeDefinitions.add(typeDef.trim());
        }
        else if (typeDef.kind !== undefined) {
            resolvedTypeDefinitions.add(print(typeDef).trim());
        }
        else {
            var type = typeof typeDef;
            throw new Error("typeDef array must contain only strings, documents, or functions, got " + type);
        }
    });
    return __spread(resolvedTypeDefinitions).join('\n');
}
//# sourceMappingURL=concatenateTypeDefs.js.map